module.exports = __webpack_public_path__ + "static/img/footer_img_wechat_dl.755b18b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/footer_img_wechat_dl.png
// module id = WsZL
// module chunks = 0